import { Colors } from "@/enums/Colors";
import { Box, Button, Menu, MenuItem, styled, Typography } from "@mui/material";
import Image from "next/image";
import React, { useEffect, useRef, useState } from "react";
import groupChatIcon from "../../../../assets/images/GroupChat.svg";
import more2 from "../../../../assets/images/moreIcon2.svg";
import privateChatIcon from "../../../../assets/images/privateChat.svg";

interface Props {
  onPrivateChatSelect: () => void;
  onGroupChatSelect: () => void;
  isHoverMenuOpen?: boolean;
}

export const LazoPortalNewChatButtonEvents = {
  OpenMenu: "LazoPortalNewChatButtonEventsOpenMenu",
};

export const LazoPortalNewChatButton: React.FC<Props> = (props: Props) => {
  /*  MENU ANCHOR */
  const [anchor, setAnchor] = useState<null | (EventTarget & HTMLButtonElement)>(null);
  const styledButtonRef = useRef<HTMLButtonElement>(null);
  const handleCloseMenu = () => {
    setAnchor(null);
  };
  const onClick = (event: React.MouseEvent<HTMLButtonElement>) => {
    if (anchor !== event.currentTarget) {
      setAnchor(event.currentTarget);
    }
  };

  const id = "integrations-hover-menu";

  function openMenu(ev: CustomEvent) {
    const target = ev.detail?.target;
    setAnchor(target || styledButtonRef.current);
  }

  useEffect(() => {
    document.addEventListener(LazoPortalNewChatButtonEvents.OpenMenu, openMenu);
    return () => {
      document.removeEventListener(LazoPortalNewChatButtonEvents.OpenMenu, openMenu);
    };
  }, []);

  return (
    <>
      <StyledButton onClick={onClick} aria-owns={anchor ? id : undefined} aria-haspopup="true" ref={styledButtonRef}>
        <Image width={32} height={32} src={more2.src} alt="more" />
      </StyledButton>
      <Menu
        id={id}
        anchorEl={anchor}
        open={Boolean(anchor)}
        sx={{
          "& .MuiPaper-root": {
            marginTop: "0.25rem",
            marginLeft: "-2.5rem",
            boxShadow: " 0px 0px 20.9px 0px rgba(0, 0, 0, 0.10)",
            border: `1px solid ${Colors.LIGHT_GRAY_DEDEE1}`,
          },
          "& ul": {
            padding: "0px",
            color: Colors.LIGHT_GRAY_8A8E93,
            "& .selected": {
              color: "black",
            },
          },
        }}
        onClose={handleCloseMenu}
        MenuListProps={{ onMouseLeave: handleCloseMenu }}
        disableScrollLock={true}
      >
        <Container>
          <MenuItem
            onClick={() => {
              props.onPrivateChatSelect();
            }}
            sx={{ color: Colors.HEART_RED }}
          >
            <img alt={"private-chat"} src={privateChatIcon.src} />
            <StyledTypography>New Private Chat</StyledTypography>
          </MenuItem>
          <MenuItem
            onClick={() => {
              props.onGroupChatSelect();
            }}
            sx={{ color: Colors.HEART_RED }}
          >
            <img alt={"group-chat"} src={groupChatIcon.src} />
            <StyledTypography>New Group</StyledTypography>
          </MenuItem>
        </Container>
      </Menu>
    </>
  );
};

const StyledButton = styled(Button)(() => ({
  height: "1.5rem",
  width: "1.5rem",
  borderRadius: "50%",
  minWidth: "1.5rem",
  padding: "0px",
  "&:hover": {
    backgroundColor: Colors.BUTTON_SECONDARY_HOVER_PURPLE,
  },
}));

const StyledTypography = styled(Typography)(({}) => ({
  color: "black",
  fontSize: "14px",
  fontWeight: "500",
  marginLeft: "10px",
}));

const Container = styled(Box)(() => ({
  fontSize: "0.875rem",
  color: Colors.BLACK,
  textAlign: "center",
  "& > li": {
    paddingInline: "0.75rem",
    paddingBlock: "0.375rem",
    display: "flex",
    columnGap: "0.5rem",
  },
  "& .collaborators-item": {
    "& path": { fill: Colors.LIGHT_GRAY_8A8E93 },
  },
}));
